<template>
    <div style="margin-bottom:2em;" class="card">
        <div class="card-content">
            <div class="columns">
                <div class="column location-card">
                    
                    <p>
                        <b class="store-navigation-color">{{name}}</b>
                        <br>
                        {{address}}
                        <br>
                        <a class="store-loyalty-color" :aria-label="`store phone number is: ${getPhone()}`" v-if="getPhone()" :href="`tel:${location.contactPhone || phone}`">{{ getPhone()}}</a>
                    </p> 

                    <p> <span><a @click="emitStatus()"> {{ (showDetails) ? "Hide" : "View"}} details</a></span></p>
                    <div v-if="showDetails">
                        <p 
                            v-for="(day, index) in getWeek()" 
                            v-if="$mq !== 'mobile'"
                            :key=index>
                            {{day.startTime.format("ddd hh:mma")}} - {{day.endTime.format("hh:mma")}}
                        </p>

                        <div v-if="$mq === 'mobile' && location" class="google-map">
                            <GmapMap
                                ref="mapRef"
                                :center="{
                                        lat: location.latitude, 
                                        lng: location.longitude, 
                                }"
                                :zoom=16
                                style="width: 100%; height: 500px"
                            >
                            <google-marker-info-window
                                :location=location
                                @click="focusOnLocation(location)"
                                @closeclick="focusedLocation.id = null"
                            />
                            </GmapMap>
                        </div>
                    </div>

                </div>
                <div class="column is-narrow">
                    <div class="is-pulled-right-desktop  has-text-right has-text-centered-mobile">
                        <BaseButton
                            v-if="location.onlineStoreOpen"
                            :classNames="['is-rounded', 'store-button-color']"
                            @click="handleClickSetLocation"
							:ariaLabel="`order from store: ${name} at ${address}`"
                            :title="(location.onlineStoreOpen) ? 'Order from here' : 'Please call store'"
                        />
                        <p v-if="!location.onlineStoreOpen">
                            {{location.onlineStoreClosedMessage}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoogleMarkerInfoWindow from "@/components/store-locator/GoogleMarkerInfoWindow";
import { AsYouType } from 'libphonenumber-js'

export default {
    components: {
        "google-marker-info-window": GoogleMarkerInfoWindow
    },
    data() {
        return {
            days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
        }
    },
    methods: {
        getPhone() {
            const phone = this.location.contactPhone || this.phone;
            return (phone) ? new AsYouType('US').input(phone) :   "";
        },
        emitStatus() {
            if (this.showDetails) {
                this.$emit('emitHide', this.locationBase);
            } else {
                this.$emit('emitActive', this.locationBase);
            }
        },
        getWeek() {
            let week = [];
            let i = 0, 
                populated = 0;
            while (populated < 7 && i < this.location.locationHours.length) {
                const day = this.location.locationHours[i].startTime.day();

                if (!week[day]) {
                    week[day] = (this.location.locationHours[i]);
                    populated++;
                }
                i++;
            }
            return week;
		},
		handleClickSetLocation() {
			const $el = this.$el;
			const parentElement = $el.offsetParent.parentElement;
			if (typeof parentElement.scrollTo === 'function') {
				parentElement.scrollTo(0,0);
			}
			this.$emit('setLocation');
		}
    },
   props: {
       name: String,
       address: String,
       phone: String,
       showDetails: {
           type: Boolean,
           default: false
       },
       locationBase: String,
       location: Object
   } 
}
</script>

<style lang="scss">
    @import 'globalStyles';
       .location-card .button {
           margin-top: 1em;
       }

</style>



// WEBPACK FOOTER //
// src/components/store-locator/LocationCard.vue